<template>
  <div>
    <ServerError v-if="ServerError" />
    <v-layout wrap py-6 class="hidden-sm-and-down">
      <v-flex xs1 sm2 md2 lg2 class="hidden-xs-only"> 
      <v-spacer class="hidden-xs-only"></v-spacer>
      </v-flex>
      <v-spacer class="hidden-xs-only"></v-spacer>
      <v-flex xs3 sm2>
        <router-link class="routerlink" to="/">
          <span class="ibmsemibold medium">AGOGO</span>
        </router-link>
      </v-flex>
      <v-spacer></v-spacer>

      <v-flex sm2 md2 lg2 pr-lg-6>
        <v-layout wrap justify-end>
          <v-flex md5 lg4 xl3>
            <AccountMenu />
            <!-- <v-icon color="black">mdi-account-circle-outline</v-icon> -->
          </v-flex>
          <v-flex md5 lg4 xl3>
            <v-icon color="black">mdi-cart-outline</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center text-center class="hidden-sm-and-down">
      <v-flex xs12>
        <v-divider></v-divider>
      </v-flex>
      <v-flex sm6 py-2>
        <v-layout wrap justify-space-between class="ibmsemibold smallm">
          <v-flex align-self-center text-center v-for="(item, i) in navItems" :key="i">
            <router-link :to="item.route">
              <span
                style="color: #575757"
                :class="
                  item.route == $route.path
                    ? 'ibmbsemibold hovered activePage'
                    : 'ibmbsemibold hovered'
                "
                >{{ item.name }}</span
              >
            </router-link>
          </v-flex>
          <!-- <v-flex>
            <span>Fruits</span>
          </v-flex>
          <v-flex>
            <span>Plants</span>
          </v-flex>
          <v-flex>
            <span>Spices</span>
          </v-flex> -->
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>

    <!-- mobile  -->
    <v-app-bar
      app
      dark
      color="#ffffff"
      dense
      flat
      height="50px"
      elevation="1"
      class="hidden-md-and-up"
    >
      <v-app-bar-nav-icon @click.native="sideNav = !sideNav">
        <v-icon color="#3EA56E">mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to="/">
          <v-layout wrap justify-center>
            <v-flex xs12>
              <v-img
                src="./../../assets/Images/agogo.png"
                height="25px"
                contain
              ></v-img>
              <!-- <span class="ibmbold cblack">AGOGO</span> -->
            </v-flex>
          </v-layout>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon left class="pr-4">
        <AccountMenu />
      </v-btn>

      <v-icon color="black">mdi-cart-outline</v-icon>
    </v-app-bar>
    <v-navigation-drawer v-model="sideNav" fixed temporary color="#FFFFFF">
      <v-layout wrap justify-center>
        <v-flex
          xs12
          v-for="(item, i) in navItems"
          :key="i"
          text-center
          pa-2
          pl-4
          text-uppercase
          align-self-center
        >
          <v-layout wrap justify-center>
            <v-flex xs12 align-self-center text-left>
              <span
                class="text-capitalize"
                :style="
                  $route.query.styl == item._id
                    ? {
                        'font-family': 'ibmbold',
                      }
                    : {
                        'font-family': 'ibmthin',
                      }
                "
                style="
                  font-size: 15px;
                  color: #000;
                  letter-spacing: 3px;
                  cursor: pointer;
                "
                @click="changeStylRoute(item)"
              >
                {{ item.name }}
              </span>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center v-if="appType == 'seller'">
        <v-flex
          xs12
          v-for="(item, i) in sellerNavItems"
          :key="i"
          text-center
          pa-2
          pl-4
          text-uppercase
          align-self-center
        >
          <v-layout wrap justify-center>
            <v-flex xs12>
              <router-link :to="item.route">
                <span
                  :style="
                    $route.path == item.route
                      ? {
                          'font-family': 'ibmbold',
                        }
                      : {
                          'font-family': 'ibmthin',
                        }
                  "
                  style="
                    font-size: 15px;
                    color: #ffffff;
                    letter-spacing: 3px;
                    cursor: pointer;
                  "
                >
                  {{ item.name }}
                </span>
              </router-link>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- <v-flex xs12 text-center pa-2 pl-4 text-uppercase align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs12>
              <span
                @click="appLogout"
                style="
                  font-family: ibmthin;
                  font-size: 15px;
                  color: #ffffff;
                  letter-spacing: 3px;
                  cursor: pointer;
                "
              >
                Logout
              </span>
            </v-flex>
            <v-flex xs12 pt-2>
              <v-divider color="#fff"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex> -->
      </v-layout>
    </v-navigation-drawer>
  </div>
</template>
<script>
import AccountMenu from "./accountMenu";
export default {
  components: {
    AccountMenu,
  },
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      user: {},
      sideNav: false,
      navItems: [
        // { name: "New Arrivals", route: "/New Arrivals", type: "link" },
        // { name: "Fertilizers", route: "/Fertilizers", type: "link" },
        // { name: "Plants", route: "/Plants", type: "link" },
        // { name: "Spices", route: "/Spices", type: "link" },
        // { name: "Travel & Tourism", route: "/Tourism", type: "link" },
        // { name: "Wishlist", route: "/Wishlist", type: "link" },
        // { name: "Cart", route: "/Cart", type: "link" },
        // { name: "Profile", route: "/Profile", type: "link" },
      ],
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appType() {
      return this.$store.state.userType;
    },
  },
  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
      if (this.sideNav2 == true) {
        this.sideNav2 = false;
      }
    },
  },
};
</script>
<style scoped>
.hovered:hover {
  padding-bottom: 7px;
  border-bottom: 3px solid #3ea56e !important;
}
.activePage {
  padding-bottom: 7px;
  border-bottom: 3px solid #3ea56e !important;
}
</style>